/* VÆLD — predictive search panel.
   Opens the slide-down panel; debounced fetch of the predictive-search
   section as the visitor types; injects the rendered fragment. */

(function () {
  'use strict';

  var panel = document.querySelector('[data-search-panel]');
  if (!panel) return;

  var input = panel.querySelector('[data-search-input]');
  var results = panel.querySelector('[data-predictive-results]');
  var lastFocus = null;
  var controller = null;
  var timer = null;
  var lastQuery = '';

  function open() {
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 120);
  }

  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });

  function render(html) {
    if (!results) return;
    results.innerHTML = html;
    results.classList.toggle('is-filled', html.trim().length > 0);
  }

  function fetchResults(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
      'search/suggest?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        // The section response is wrapped in <div id="shopify-section-…">;
        // extract its inner content.
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var sec = doc.querySelector('.psearch, .psearch__empty');
        render(sec ? sec.outerHTML : '');
      })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) { render(''); return; }
      timer = setTimeout(function () { fetchResults(q); }, 220);
    });
  }
})();
